<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para">Angus MacDonald has lived all his life in the Highlands and is steeped in its history. He built up several successful businesses before changing his career to write the Ardnish trilogy, open a large bookshop and build the Highland Cinema in Fort William.</p>
<p class="para2">Praise for <em>Ardnish Was Home</em>, Part 2 of the Ardnish series</p>
<p class="para1">‘A genuine portrait of a time gone forever . . . a very good read’</p>
<p class="para">Rosamunde Pilcher</p>
<p class="para1">‘What I really enjoyed about this book was its beauty, an enthralling read that is both brutal and poetic’</p>
<p class="para"><em>Daily Record</em></p>
<p class="para1">‘A fast-paced narrative with deeply likeable characters . . . far more than yet another wartime love story . . . impossible to put down’</p>
<p class="para"><em>Scottish Field</em>, Book of the month</p>
<p class="para1">‘Extraordinary. I closed the book with the strong feeling of the importance of kinship, the need to nurture one another, and the power of love. It will enter your soul’</p>
<p class="para"><em>Scots Magazine</em></p>
<p class="para1">‘An evocative book opening a window on a way of life as it was, a century ago, in Ardnish, in the West Highlands . . . a compelling account of peace and war’</p>
<p class="para"><em>Women Together</em></p>
<div class="page-break">
<p class="para"> </p>
<p class="para2">Praise for <em>We Fought for Ardnish</em>, Part 3 of the Ardnish series</p>
<p class="para2">‘An intense and bittersweet love story . . . the descriptions of travel from Italy to Canada and the Italian front combine to make this a compelling and engaging story’</p>
<p class="para"><em>Scottish Field</em></p>
<p class="para1">‘A captivating novel . . . which incorporates so much of the beautiful Highland scene and its people alongside the horrors and destruction of a war-torn world. An inspiring read’</p>
<p class="para"><em>The Braes</em></p>
<p class="para1">‘Not only a gripping and at times horrifying adventure . . . it is also an important piece of social history. But perhaps above all, it is a tale of the importance of true love and determination’</p>
<p class="para"><em>Scots Magazine</em></p>
<p class="para1">‘An excellent reflection of love of one’s home and heritage. A page turner’</p>
<p class="para"><em>Oban Times</em></p>
<p class="para1">‘A haunting salute to a past way of life and a testament to the timeless values of loyalty, faith and family’</p>
<p class="para"><em>National Post</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm-01.vue?4c9e9017